"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MobileMenu = /*#__PURE__*/function () {
  function MobileMenu() {
    _classCallCheck(this, MobileMenu);
    this._mobileIcon = $("#menuIcon");
    this._mobileMenu = $("#mobileMenu");
    this._dropDownOpenerIcon = $(".openDropDown");
    this._header = $("header");
    this.clickToMobileIcon();
    this.clickToDropdownIcon();
  }
  return _createClass(MobileMenu, [{
    key: "clickToMobileIcon",
    value: function clickToMobileIcon() {
      var _this2 = this;
      this._mobileIcon.click(function (e) {
        _this2._headerHeight = _this2.getCurrentHeaderHeight();
        var _this = $(e.currentTarget);
        var isActive = _this.attr("data-active");
        _this2.setMobileMenuCSSTop(_this2._headerHeight);
        if (isActive === "true") {
          _this.attr("data-active", "false");
          _this2.enablePageScrolling();
          _this2._mobileMenu.slideUp(600);
        } else {
          _this.attr("data-active", "true");
          _this2.disablePageScrolling();
          _this2._mobileMenu.slideDown(600);
        }
      });
    }
  }, {
    key: "clickToDropdownIcon",
    value: function clickToDropdownIcon() {
      this._dropDownOpenerIcon.click(function (e) {
        var _this = $(e.currentTarget);
        var dropDownMenu = _this.parents("li").next("li");
        var isDropDownMenuActive = dropDownMenu.hasClass("active");
        if (isDropDownMenuActive) {
          dropDownMenu.removeClass("active");
          _this.removeClass("active");
        } else {
          dropDownMenu.addClass("active");
          _this.addClass("active");
        }
        dropDownMenu.slideToggle();
      });
    }
  }, {
    key: "setMobileMenuCSSTop",
    value: function setMobileMenuCSSTop(val) {
      this._mobileMenu.css("top", val);
    }
  }, {
    key: "getCurrentHeaderHeight",
    value: function getCurrentHeaderHeight() {
      return this._header.outerHeight();
    }
  }, {
    key: "disablePageScrolling",
    value: function disablePageScrolling() {
      $("html,body").addClass("stopScroll");
      $("html,body").on("touchmove", function (e) {
        e.preventDefault();
      });
      this._mobileMenu.on("touchmove", function (e) {
        return true;
      });
    }
  }, {
    key: "enablePageScrolling",
    value: function enablePageScrolling() {
      $("html,body").removeClass("stopScroll");
      $("html,body").on("touchmove", function (e) {
        return true;
      });
    }
  }]);
}();